import * as React from 'react'
import { classes, media, style as _style } from 'typestyle'

/* Components =================================================================================== */
import { Box } from '../box/box.component'
import { Line } from '../line'
import { Heading } from '../text/heading.component'

/* Styles ======================================================================================= */
import { tabClass } from './tab.class'
import { mb12 } from '../../styles/styleset/margin/mb12'
import { p16 } from '../../styles/styleset/padding/p16'
import { pb0i } from '../../styles/styleset/padding/pb0i'

/* Types ======================================================================================== */
type TabProps = {
  style?: React.CSSProperties
  children?: any
  className?: string
  label?: string | JSX.Element
  currentStep?: number
  step?: number
  hidden?: boolean
  hasError?: boolean
  highlight?: boolean
}

/* <Tab /> ====================================================================================== */
const TabComponent: React.FC<TabProps> = props => {
  const { className, children, style, currentStep, step, highlight } = props

  const { base, proped } = tabClass.setProps({})
  const active = currentStep !== undefined && step !== undefined && currentStep === step

  return (
    <div className={classes('aeki-tab', base, active && proped.active, className)} style={style}>
      <Box
        className={classes(
          p16,
          pb0i,
          _style({
            display: 'none',
            background: highlight ? '#fff0c7' : '',
            ...media(
              { type: 'print' },
              {
                display: 'flex',
                flexDirection: 'column',
                pageBreakInside: 'avoid',
                padding: 0,
                marginBottom: 8,
              },
            ),
          }),
        )}
      >
        <Heading className={mb12} semiBold>
          {props.label}
        </Heading>
        <Line dark />
      </Box>
      {children}
    </div>
  )
}

/* Export ======================================================================================= */
export const Tab = TabComponent
